export default __webpack_public_path__ + "static/media/avatar.7450119e.svg";